
const digest = 'b815d2c4a0714004465acccb1f5f134623bfa6de6dec194d5e34d9595601accd';
const classes = {"wrapper":"_wrapper_b2zq2_1"};
const css = `._wrapper_b2zq2_1 {
  font-family: Rubik, "sans-serif";
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  